import React from 'react';
import { LabelStyled, SelectStyled } from '../../../../components/InputSelect/styles';
import { ActionBarStyled } from '../../../../components/PageAction/styles';
import { FlexboxStyled } from '../../../../styles/IndexStyles';
import { RecipientsState } from './types';

// do not change values there is a enum in the newsletter postgres table that depends on these values: 'all' | 'researchers' | 'volunteers'
const emailRecipientsOptions = [
  { value: 'all', label: 'All recipients' },
  { value: 'researchers', label: 'Researchers' },
  { value: 'volunteers', label: 'Volunteers' },
];

export const EmailRecipientsSelect = ({
  initialValue,
  handleChange,
}: {
  initialValue: RecipientsState;
  handleChange: (changedValue: any) => void;
}) => (
  <ActionBarStyled>
    <FlexboxStyled style={{ marginBottom: 0 }}>
      <LabelStyled style={{ color: 'black' }}>Email Recipients</LabelStyled>
      <SelectStyled
        id="action"
        onChange={({ currentTarget }: React.ChangeEvent<HTMLSelectElement>) => {
          handleChange({ recipients: currentTarget?.value });
        }}
        value={initialValue.recipients}
      >
        {emailRecipientsOptions.map(({ label, value }, i) => (
          <option value={value} key={i}>
            {label}
          </option>
        ))}
      </SelectStyled>
    </FlexboxStyled>
  </ActionBarStyled>
);
